import { render } from "./issuesStatus.vue?vue&type=template&id=57611346&scoped=true"
import script from "./issuesStatus.vue?vue&type=script&lang=js"
export * from "./issuesStatus.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-57611346"

export default script